module.exports = __webpack_public_path__ + "static/media/mongodb-light.3d40302b.png";